import { version, versionDate, description } from '../package.json'

export default {
	hosts: [
		{
			appauth: 'xQ8Uyf5yBL8zL6Dg',
			name: 'wisenetwork',
			domain: 'https://wisenetwork.fi',
			baseUrl: 'https://wisenetwork.fi',
			ajaxUrl: 'https://ajax.wisenetwork.fi',
			restUrl: 'https://api.wnw.fi/api/1.0/', //Change this later!
			ecomUrl: 'https://kauppa.wisenetwork.fi',
			useRestLogin: false,
			useGolfFeatures: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: true,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'WiseGym',
			displayChainName: 'WiseGym',
			className: 'wisegym-wnw',
			registerMailingLists: [1],
			customerTermsArticleId: null, 
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 9,
					textQuestionId: 5,
					contactQuestionId: 6
				}
			}
		},
		{
			appauth: 'ZEArxdAFCfXE7sSJ',
			name: 'wnw',
			domain: 'https://wnw.fi/',
			baseUrl: 'https://wnw.fi/',
			ajaxUrl: 'https://ajax.wnw.fi/',
			restUrl: 'https://api.wnw.fi/api/1.0/',
			ecomUrl: 'https://kauppa.wnw.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: true,
			showContractCancelButton: true,
			showNumberOfPeopleInside: true,
			useTabDescriptions: true,
			useEventAddress: true,
			useServices: true,
			useServicesTab: false,
			useEventCategoryNamePill: true,
			useSecondaryShop: false,
			useCalendarTile: false,
			usePersonLink: true,
			useBenefits: true,
			useGenderSelector: true,
			useBookingTab: true,
			currency: "$",
			useWebsiteLink: true,
			showStep2Fit: true,
			showTrainero: true,
			showStrivee: true,
			showStep2FitInList: true,
			useGlobalArticles: true,
			secondaryShopName: 'Lahnakauppa',
			openSecondaryShopLink: 'https://kauppa.wnw.fi',
			bookingUrl: 'https://kauppa.wnw.fi',
			displayName: 'WNW',
			displayChainName: 'WNW',
			className: 'wisegym-wnw',
			registerMailingLists: [1],
			contractTerminationArticleId: 4739,
			customerTermsArticleId: 3910,
			linkedSystems: [
				{displayName: 'wnw-local'},
			],
			terminateSurveyData: {
				custTerminateSurvey: {
					surveyId: 1391,
					textQuestionId: 842
				}
			},
			// Support form, these have to be updated!
			surveyHash: '40e70554',
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 470,
					textQuestionId: 637,
					contactQuestionId: 579
				}
			},
			// Android and iOS link handling
			platformLinkHandling: {
				android: {
					openArticleInIAB: false,
					openSecondaryShopInExternalBrowser: false,
					openShopInExternalBrowser: false,
					openWebsiteInExternalBrowser: false
				},
				ios: {
					openArticleInIAB: false,
					openSecondaryShopInExternalBrowser: false,
					openShopInExternalBrowser: false,
					openWebsiteInExternalBrowser: false
				}
			},
		},
		{
            appauth: 'ZEArxdAFCfXE7sS',
            name: 'wnw-local',
            domain: 'http://wisedemo5.fi:8080/',
            baseUrl: 'http://wisedemo5.fi:8080/',
            ajaxUrl: 'http://ajax.wisedemo5.fi:8080/',
            restUrl: 'http://api.wisedemo5.fi:8080/api/1.0/',
            ecomUrl: 'http://kauppa.wisedemo5.fi:8080',
            useRestLogin: false,
            useFitness: true,
            showWodConnect: true,
            showContractCancelButton: true,
            showNumberOfPeopleInside: true,
            useTabDescriptions: true,
            useEventAddress: true,
            useEventCategoryNamePill: true,
            useSecondaryShop: false,
			usePersonLink: true,
            useCalendarTile: false,
            useBenefits: true,
            useBookingTab: true,
            showStep2Fit: true,
            showTrainero: true,
			useGenderSelector: true,
            showStrivee: true,
            showStep2FitInList: true,
            secondaryShopName: 'Lahnakauppa',
            openSecondaryShopLink: 'https://kauppa.wnw.fi',
            bookingUrl: 'https://kauppa.wnw.fi',
            displayName: 'wnw-local',
            displayChainName: 'wnw-local',
            className: 'wisegym-wnw-local',
            registerMailingLists: [1],
            customerTermsArticleId: 3910,
			linkedSystems: [
				{displayName: 'WNW'},
			],
            terminateSurveyData: {
                custTerminateSurvey: {
                    surveyId: 1391,
                    textQuestionId: 842
                }
            },
            useCourses: true,
		},
		{
			appauth: '5TmX0A8F70MASvAQw',
			name: 'viregym',
			domain: 'https://viregym.fi',
			baseUrl: 'https://viregym.fi',
			ajaxUrl: 'https://ajax.viregym.fi',
			restUrl: 'https://api.viregym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.viregym.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: true,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			minimumEntriesToShow: 5,
			displayName: 'VireGym',
			displayChainName: 'VireGym',
			className: 'wisegym-viregym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: 'eQjegrnKOTzL6Dg',
			name: 'thepark',
			domain: 'https://thepark.fi',
			baseUrl: 'https://thepark.fi',
			ajaxUrl: 'https://ajax.thepark.fi',
			restUrl: 'https://api.thepark.fi/api/1.0/',
			ecomUrl: 'https://kauppa.thepark.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: true,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'The Park',
			displayChainName: 'The Park',
			className: 'wisegym-thepark',
			registerMailingLists: [1],
			customerTermsArticleId: 13,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 1,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: '5Ekdwne70MASvAQw',
			name: 'crossfiteastturku',
			domain: 'https://crossfiteastturku.fi',
			baseUrl: 'https://crossfiteastturku.fi',
			ajaxUrl: 'https://ajax.crossfiteastturku.fi',
			restUrl: 'https://api.crossfiteastturku.fi/api/1.0/',
			ecomUrl: 'https://kauppa.crossfiteastturku.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: true,
			showContractCancelButton: true,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'CrossFit East Turku',
			displayChainName: 'CrossFit East Turku',
			className: 'wisegym-crossfiteastturku',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 1903,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'ekmmEksrmWIASvAQw',
			name: 'korsogym',
			domain: 'https://korsogym.fi',
			baseUrl: 'https://korsogym.fi',
			ajaxUrl: 'https://ajax.korsogym.fi',
			restUrl: 'https://api.korsogym.fi/api/1.0/',
			ecomUrl: 'https://korsogym.fi/kauppa',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'Korso Gym',
			displayChainName: 'Korso Gym',
			className: 'wisegym-korsogym',
			registerMailingLists: [1],
			customerTermsArticleId: 108,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 1165,
					textQuestionId: 23,
					contactQuestionId: 24
				}
			}
		},
		{
			appauth: 'wremEms8F70MASvAQw',
			name: 'kuntosalus',
			domain: 'https://kuntosalus.fi',
			baseUrl: 'https://kuntosalus.fi',
			ajaxUrl: 'https://ajax.kuntosalus.fi',
			restUrl: 'https://api.kuntosalus.fi/api/1.0/',
			ecomUrl: 'https://kauppa.kuntosalus.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'KuntoSalus',
			displayChainName: 'KuntoSalus',
			className: 'wisegym-kuntosalus',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			linkedSystems: [
				{displayName: 'LadySalus'},
			],
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 898,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'tbb8tapjkb6gcu8j3z6h',
			name: 'ladysalus',
			domain: 'https://ladysalus.fi',
			baseUrl: 'https://ladysalus.fi',
			ajaxUrl: 'https://ajax.ladysalus.fi',
			restUrl: 'https://api.ladysalus.fi/api/1.0/',
			ecomUrl: 'https://kauppa.ladysalus.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'LadySalus',
			displayChainName: 'LadySalus',
			className: 'wisegym-ladysalus',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			linkedSystems: [
				{displayName: 'KuntoSalus'},
			],
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 555,
					textQuestionId: 6,
					contactQuestionId: 7
				}
			}
		},
		{
			appauth: 'xe8w2uhjm5ezvxjvwoya',
			name: 'korttelisali',
			domain: 'https://korttelisali.fi',
			baseUrl: 'https://korttelisali.fi',
			ajaxUrl: 'https://ajax.korttelisali.fi',
			restUrl: 'https://api.korttelisali.fi/api/1.0/',
			ecomUrl: 'https://kauppa.korttelisali.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			minimumEntriesToShow: 5,
			displayName: 'Korttelisali',
			displayChainName: 'Korttelisali',
			className: 'wisegym-korttelisali',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'ekekmX0A8F70MASvAQw',
			name: 'hugesports',
			domain: 'https://hugesports.fi',
			baseUrl: 'https://hugesports.fi',
			ajaxUrl: 'https://ajax.hugesports.fi',
			restUrl: 'https://api.hugesports.fi/api/1.0/',
			ecomUrl: 'https://kauppa.hugesports.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'HUGE - Huittinen Go eSports',
			displayChainName: 'HUGE - Huittinen Go eSports',
			className: 'wisegym-hugesports',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 6,
					textQuestionId: 4,
					contactQuestionId: 5
				}
			}
		},
		{
			appauth: 'parjux2j5tg66sq2exf6',
			name: 'gym23',
			domain: 'https://gym23.fi',
			baseUrl: 'https://gym23.fi',
			ajaxUrl: 'https://ajax.gym23.fi',
			restUrl: 'https://api.gym23.fi/api/1.0/',
			ecomUrl: 'https://kauppa.gym23.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'Gym23',
			displayChainName: 'Gym23',
			className: 'wisegym-gym23',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'TMVKarkGuvQqXkAW',
			name: 'saloragym',
			domain: 'https://saloragym.fi',
			baseUrl: 'https://saloragym.fi',
			ajaxUrl: 'https://ajax.saloragym.fi',
			restUrl: 'https://api.saloragym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.saloragym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'Salora Gym',
			displayChainName: 'Salora Gym',
			className: 'wisegym-saloragym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 542,
					textQuestionId: 240,
					contactQuestionId: 41
				}
			}
		},
		{
			appauth: '3mrxvu5ui4p6fsceg8ps',
			name: 'mmalabporvoo',
			domain: 'https://mmalab.fi',
			baseUrl: 'https://mmalab.fi',
			ajaxUrl: 'https://ajax.mmalab.fi',
			restUrl: 'https://api.mmalab.fi/api/1.0/',
			ecomUrl: 'https://kauppa.mmalab.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: true,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'MMA Lab Porvoo',
			displayChainName: 'MMA Lab Porvoo',
			className: 'wisegym-mmalabporvoo',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 57,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'ue98f9mu75rxc9nynd3y',
			name: 'crossfitpihka',
			domain: 'https://crossfitpihka.com',
			baseUrl: 'https://crossfitpihka.com',
			ajaxUrl: 'https://ajax.crossfitpihka.com',
			restUrl: 'https://api.crossfitpihka.com/api/1.0/',
			ecomUrl: 'https://kauppa.crossfitpihka.com',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			showStrivee: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'Crossfit Pihka',
			displayChainName: 'Crossfit Pihka',
			className: 'wisegym-crossfitpihka',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 6,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'btgenzbi2dx27qnfcytr',
			name: 'connectfit',
			domain: 'https://connectfit.fi',
			baseUrl: 'https://connectfit.fi',
			ajaxUrl: 'https://ajax.connectfit.fi',
			restUrl: 'https://api.connectfit.fi/api/1.0/',
			ecomUrl: 'https://kauppa.connectfit.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'ConnectFit',
			displayChainName: 'ConnectFit',
			className: 'wisegym-connectfit',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'o84yy5jvfw2gh9t9kfw3',
			name: 'marswiese',
			domain: 'https://marswiese.fi',
			baseUrl: 'https://marswiese.fi',
			ajaxUrl: 'https://ajax.marswiese.fi',
			restUrl: 'https://api.marswiese.fi/api/1.0/',
			ecomUrl: 'https://kauppa.marswiese.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'Marswiese',
			displayChainName: 'Marswiese',
			className: 'wisegym-marswiese',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 20,
					textQuestionId: 17,
					contactQuestionId: 18
				}
			}
		},

		{
			appauth: 'mpn6g6wfro78qs55gfqv',
			name: 'crossfitmyrsky',
			domain: 'https://crossfitmyrsky.fi',
			baseUrl: 'https://crossfitmyrsky.fi',
			ajaxUrl: 'https://ajax.crossfitmyrsky.fi',
			restUrl: 'https://api.crossfitmyrsky.fi/api/1.0/',
			ecomUrl: 'https://kauppa.crossfitmyrsky.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: true,
			useSecondaryShop: false,
			displayName: 'Crossfit Myrsky',
			displayChainName: 'Crossfit Myrsky',
			className: 'wisegym-crossfitmyrsky',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 6,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'aq33kjhbb89jveyhe6tw',
			name: 'bbfgym',
			domain: 'https://bbfgym.fi',
			baseUrl: 'https://bbfgym.fi',
			ajaxUrl: 'https://ajax.bbfgym.fi',
			restUrl: 'https://api.bbfgym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.bbfgym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			showNumberOfPeopleInside: true,
			useTabDescriptions: false,
			useEventAddress: false,
			useSecondaryShop: false,
			displayName: 'BBFGym',
			displayChainName: 'BBFGym',
			className: 'wisegym-bbfgym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 40,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: 'SfCJn6ZbDhGvAfBvai7H',
			name: 'luvigym',
			domain: 'https://luvianjaahalli.fi',
			baseUrl: 'https://luvianjaahalli.fi',
			ajaxUrl: 'https://ajax.luvianjaahalli.fi',
			restUrl: 'https://api.luvianjaahalli.fi/api/1.0/',
			ecomUrl: 'https://kauppa.luvianjaahalli.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: true,
			useSecondaryShop: false,
			displayName: 'LuviGym',
			displayChainName: 'LuviGym',
			className: 'wisegym-luvigym',
			registerMailingLists: [1],
			customerTermsArticleId: 1,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 70,
					textQuestionId: 52,
					contactQuestionId: 53
				}
			}
		},
		{
			appauth: 'jrnjJwukU3brfjN3yhe6tw',
			name: 'oasisgym',
			domain: 'https://oasisgym.fi',
			baseUrl: 'https://oasisgym.fi',
			ajaxUrl: 'https://ajax.oasisgym.fi',
			restUrl: 'https://api.oasisgym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.oasisgym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: true,
			useSecondaryShop: false,
			displayName: 'Oasis Gym & Fitness',
			displayChainName: 'Oasis Gym & Fitness',
			className: 'wisegym-oasisgym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 219,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: 'fkmWoA8F70MASvAQw',
			name: 'blocksport',
			domain: 'https://blocksport.fi',
			baseUrl: 'https://blocksport.fi',
			ajaxUrl: 'https://ajax.blocksport.fi',
			restUrl: 'https://api.blocksport.fi/api/1.0/',
			ecomUrl: 'https://kauppa.blocksport.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: true,
			useSecondaryShop: false,
			displayName: 'BlockSport',
			displayChainName: 'BlockSport',
			className: 'wisegym-blocksport',
			registerMailingLists: [1],
			customerTermsArticleId: 1,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 18,
					textQuestionId: 18,
					contactQuestionId: 19
				}
			}
		},
		{
			appauth: '5krmsafF70MASvAQw',
			name: 'fnxperformance',
			domain: 'https://fnxperformance.com',
			baseUrl: 'https://fnxperformance.com',
			ajaxUrl: 'https://ajax.fnxperformance.com',
			restUrl: 'https://api.fnxperformance.com/api/1.0/',
			ecomUrl: 'https://kauppa.fnxperformance.com',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: true,
			useSecondaryShop: false,
			displayName: 'Fnx Performance',
			displayChainName: 'Fnx Performance',
			className: 'wisegym-fnxperformance',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 10,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: '8VZNArtS94GQuD8haV4c',
			name: 'porvoonkk',
			domain: 'https://porvoonkuntoklubi.fi',
			baseUrl: 'https://porvoonkuntoklubi.fi',
			ajaxUrl: 'https://ajax.porvoonkuntoklubi.fi',
			restUrl: 'https://api.porvoonkuntoklubi.fi/api/1.0/',
			ecomUrl: 'https://kauppa.porvoonkuntoklubi.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Porvoon Kuntoklubi',
			displayChainName: 'Porvoon Kuntoklubi',
			className: 'wisegym-porvoonkk',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 9,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'ijrk3iejjDjndwj3jkjdfneinj',
			name: 'ahtialankuntosali',
			domain: 'https://ahtialankuntosali.fi',
			baseUrl: 'https://ahtialankuntosali.fi',
			ajaxUrl: 'https://ajax.ahtialankuntosali.fi',
			restUrl: 'https://api.ahtialankuntosali.fi/api/1.0/',
			ecomUrl: 'https://kauppa.ahtialankuntosali.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: true,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'ahtialankuntosali',
			displayChainName: 'Ahtialan kuntosali / CHSF',
			className: 'wisegym-ahtialankuntosali',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 7,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: '5rkmj2ijndioIJ38nSvAQw',
			name: 'blackhillgym',
			domain: 'https://blackhillgym.fi',
			baseUrl: 'https://blackhillgym.fi',
			ajaxUrl: 'https://ajax.blackhillgym.fi',
			restUrl: 'https://api.blackhillgym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.blackhillgym.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'blackhillgym',
			displayChainName: 'Blackhill Gym',
			className: 'wisegym-blackhillgym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: '3w85C3Bo555B22PAh',
			name: 'olefittampella',
			domain: 'https://olefittampella.fi',
			baseUrl: 'https://olefittampella.fi',
			ajaxUrl: 'https://ajax.olefittampella.fi',
			restUrl: 'https://api.olefittampella.fi/api/1.0/',
			ecomUrl: 'https://kauppa.olefittampella.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'olefittampella',
			displayChainName: 'Ole.Fit Tampella',
			className: 'wisegym-olefittampella',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 39,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: '26d784x4527X9v73n',
			name: 'elimaenkuntosali',
			domain: 'https://elimaenkuntosali.fi',
			baseUrl: 'https://elimaenkuntosali.fi',
			ajaxUrl: 'https://ajax.elimaenkuntosali.fi',
			restUrl: 'https://api.elimaenkuntosali.fi/api/1.0/',
			ecomUrl: 'https://kauppa.elimaenkuntosali.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'elimaenkuntosali',
			displayChainName: 'Elimäen Kuntosali',
			className: 'wisegym-elimaenkuntosali',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 26,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'dejwnkjDNiSvAQw',
			name: 'punttix',
			domain: 'https://punttix.fi',
			baseUrl: 'https://punttix.fi',
			ajaxUrl: 'https://ajax.punttix.fi',
			restUrl: 'https://api.punttix.fi/api/1.0/',
			ecomUrl: 'https://kauppa.punttix.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: true,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'punttix',
			displayChainName: 'PunttiX',
			className: 'wisegym-punttix',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: '5TfdfmX0A8F70MFddFvAQw',
			name: 'fitmerilappi',
			domain: 'https://fitmerilappi.fi',
			baseUrl: 'https://fitmerilappi.fi',
			ajaxUrl: 'https://ajax.fitmerilappi.fi',
			restUrl: 'https://api.fitmerilappi.fi/api/1.0/',
			ecomUrl: 'https://kauppa.fitmerilappi.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: true,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: true,
			useSecondaryShop: false,
			displayName: 'fitmerilappi',
			displayChainName: 'Fit Meri-Lappi',
			className: 'wisegym-fitmerilappi',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'DkrmmX0A8F70MASvAQw',
			name: 'studiowire',
			domain: 'https://studiowire.fi',
			baseUrl: 'https://studiowire.fi',
			ajaxUrl: 'https://ajax.studiowire.fi',
			restUrl: 'https://api.studiowire.fi/api/1.0/',
			ecomUrl: 'https://kauppa.studiowire.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: true,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'studiowire',
			displayChainName: 'Studio Wire',
			className: 'wisegym-studiowire',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'kekmX0A8F70MASvAQw',
			name: 'crossfitporvoo',
			domain: 'https://crossfitporvoo.com',
			baseUrl: 'https://crossfitporvoo.com',
			ajaxUrl: 'https://ajax.crossfitporvoo.com',
			restUrl: 'https://api.crossfitporvoo.com/api/1.0/',
			ecomUrl: 'https://kauppa.crossfitporvoo.com',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: true,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'crossfitporvoo',
			displayChainName: 'Crossfit Porvoo',
			className: 'wisegym-crossfitporvoo',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 6,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'rmDIX0ADjimdijAQw',
			name: 'voimapajalohja',
			domain: 'https://voimapajalohja.fi',
			baseUrl: 'https://voimapajalohja.fi',
			ajaxUrl: 'https://ajax.voimapajalohja.fi',
			restUrl: 'https://api.voimapajalohja.fi/api/1.0/',
			ecomUrl: 'https://kauppa.voimapajalohja.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Voimapajalohja',
			displayChainName: 'Voimapaja Lohja',
			className: 'wisegym-voimapajalohja',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'Edsdsdf4432443ohokgmderere',
			name: 'laukaagym',
			domain: 'https://laukaagym.fi',
			baseUrl: 'https://laukaagym.fi',
			ajaxUrl: 'https://ajax.laukaagym.fi',
			restUrl: 'https://api.laukaagym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.laukaagym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Laukaagym',
			displayChainName: 'Laukaa Gym',
			className: 'wisegym-laukaagym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 5,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'kWGv8T93FH2s34u6o',
			name: 'walimo',
			domain: 'https://walimo.fi',
			baseUrl: 'https://walimo.fi',
			ajaxUrl: 'https://ajax.walimo.fi',
			restUrl: 'https://api.walimo.fi/api/1.0/',
			ecomUrl: 'https://kauppa.walimo.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Walimo',
			displayChainName: 'Walimo',
			className: 'wisegym-walimo',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 185,
					textQuestionId: 14,
					contactQuestionId: 15
				}
			}
		},
		{
			appauth: 'rjnMDijMDjrnfiDJric',
			name: 'fysiox',
			domain: 'https://fysiox.fi',
			baseUrl: 'https://fysiox.fi',
			ajaxUrl: 'https://ajax.fysiox.fi',
			restUrl: 'https://api.fysiox.fi/api/1.0/',
			ecomUrl: 'https://kauppa.fysiox.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'FysioX',
			displayChainName: 'FysioX',
			className: 'wisegym-fysiox',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 185,
					textQuestionId: 14,
					contactQuestionId: 15
				}
			}
		},
		{
			appauth: 'f5lLVJPuFoXeWNmP',
			name: 'vilperigym',
			domain: 'https://vilperigym.fi',
			baseUrl: 'https://vilperigym.fi',
			ajaxUrl: 'https://ajax.vilperigym.fi',
			restUrl: 'https://api.vilperigym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.vilperigym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'VilperiGym',
			displayChainName: 'Vilperi Gym',
			className: 'wisegym-vilperigym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 185,
					textQuestionId: 14,
					contactQuestionId: 15
				}
			}
		},
		{
			appauth: 'ny4M40mQkPYNPOF8',
			name: 'wisedemosweden',
			domain: 'https://wisedemo17.fi',
			baseUrl: 'https://wisedemo17.fi',
			ajaxUrl: 'https://ajax.wisedemo17.fi',
			restUrl: 'https://api.wisedemo17.fi/api/1.0/',
			ecomUrl: 'https://kauppa.wisedemo17.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
            displayName: 'WisePlatform Gym @ Unbroken',
            displayChainName: 'WisePlatform Gym @ Unbroken',
			className: 'wisegym-wisegymsweden',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 7,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
			{
			appauth: 'Jdnfijekj3u8JDjrfu48jDJ',
			name: 'treeninpaikka',
			domain: 'https://treeninpaikka.fi',
			baseUrl: 'https://treeninpaikka.fi',
			ajaxUrl: 'https://ajax.treeninpaikka.fi',
			restUrl: 'https://api.treeninpaikka.fi/api/1.0/',
			ecomUrl: 'https://kauppa.treeninpaikka.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'TreeninPaikka',
			displayChainName: 'TreeninPaikka',
			className: 'wisegym-treeninpaikka',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 7,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'tkK3jDorjasdJfnndjDJ',
			name: 'virtagym',
			domain: 'https://virtagym.fi',
			baseUrl: 'https://virtagym.fi',
			ajaxUrl: 'https://ajax.virtagym.fi',
			restUrl: 'https://api.virtagym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.virtagym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'VirtaGym',
			displayChainName: 'VirtaGym',
			className: 'wisegym-virtagym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 7,
					textQuestionId: 7,
					contactQuestionId: 8
				}
			}
		},
		{
			appauth: 'K3jDorjasdJfnasRsfSFg',
			name: 'aidosti',
			domain: 'https://aidosti.fi',
			baseUrl: 'https://aidosti.fi',
			ajaxUrl: 'https://ajax.aidosti.fi',
			restUrl: 'https://api.aidosti.fi/api/1.0/',
			ecomUrl: 'https://kauppa.aidosti.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Aidosti',
			displayChainName: 'Aidosti',
			className: 'wisegym-aidosti',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 19,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'JDntun38nDbtgnDihtgk',
			name: 'ykkoshockeycenter',
			domain: 'https://ykkoshockey.fi',
			baseUrl: 'https://ykkoshockey.fi',
			ajaxUrl: 'https://ajax.ykkoshockey.fi',
			restUrl: 'https://api.ykkoshockey.fi/api/1.0/',
			ecomUrl: 'https://kauppa.ykkoshockey.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Ykkös Hockey Center',
			displayChainName: 'Ykkös Hockey Center',
			className: 'wisegym-ykkoshockeycenter',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 28,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'rjnDj48jDFntgujDEj9jfntikde',
			name: 'Universal Performance',
			domain: 'https://uphelsinki.com',
			baseUrl: 'https://uphelsinki.com',
			ajaxUrl: 'https://ajax.uphelsinki.com',
			restUrl: 'https://api.uphelsinki.com/api/1.0/',
			ecomUrl: 'https://kauppa.uphelsinki.com',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Universal Performance',
			displayChainName: 'Universal Performance',
			className: 'wisegym-uphelsinki',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 16,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: 'cnkDjjtindjDJj48jDFk',
			name: 'Potentia Gym',
			domain: 'https://potentiagym.fi',
			baseUrl: 'https://potentiagym.fi',
			ajaxUrl: 'https://ajax.potentiagym.fi',
			restUrl: 'https://api.potentiagym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.potentiagym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Potentia Gym',
			displayChainName: 'Potentia Gym',
			className: 'wisegym-potentiagym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 16,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: 'Dkrjtki9MNDkrgto',
			name: 'taffii',
			domain: 'https://taffii.fi',
			baseUrl: 'https://taffii.fi',
			ajaxUrl: 'https://ajax.taffii.fi',
			restUrl: 'https://api.taffii.fi/api/1.0/',
			ecomUrl: 'https://kauppa.taffii.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Liikuntakeskus Taffii',
			displayChainName: 'Liikuntakeskus Taffii',
			className: 'wisegym-taffii',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 7,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'DnrfnDeijfiEuhrdkDj',
			name: 'butrainingcenter',
			domain: 'https://butc.fi',
			baseUrl: 'https://butc.fi',
			ajaxUrl: 'https://ajax.butc.fi',
			restUrl: 'https://api.butc.fi/api/1.0/',
			ecomUrl: 'https://kauppa.butc.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'BU Training Center',
			displayChainName: 'BU Training Center',
			className: 'wisegym-butrainingcenter',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 10,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: '2TmX0A8F70adgaet1S',
			name: 'kovettugym',
			domain: 'https://kovettugym.fi',
			baseUrl: 'https://kovettugym.fi',
			ajaxUrl: 'https://ajax.kovettugym.fi',
			restUrl: 'https://api.kovettugym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.kovettugym.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: false,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Kovettu Gym',
			displayChainName: 'Kovettu Gym',
			className: 'wisegym-kovettugym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 6,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'ffmrijm523dfDikrgnfk',
			name: 'CrossFit Karjaranta',
			domain: 'https://crossfitkarjaranta.fi',
			baseUrl: 'https://crossfitkarjaranta.fi',
			ajaxUrl: 'https://ajax.crossfitkarjaranta.fi',
			restUrl: 'https://api.crossfitkarjaranta.fi/api/1.0/',
			ecomUrl: 'https://kauppa.crossfitkarjaranta.fi',
			useRestLogin: false,
			useFitness: true,
			showWodConnect: true,
			showContractCancelButton: false,
			useTabDescriptions: true,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'CrossFit Karjaranta',
			displayChainName: 'CrossFit Karjaranta',
			className: 'wisegym-crossfitkarjaranta',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 218,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
		{
			appauth: 'ghka79GJSASBfasdy',
			name: 'ilolagym',
			domain: 'https://ilolagym.fi',
			baseUrl: 'https://ilolagym.fi',
			ajaxUrl: 'https://ajax.ilolagym.fi',
			restUrl: 'https://api.ilolagym.fi/api/1.0/',
			ecomUrl: 'https://kauppa.ilolagym.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: true,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'IlolaGym',
			displayChainName: 'IlolaGym',
			className: 'wisegym-ilolagym',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 7,
					textQuestionId: 3,
					contactQuestionId: 4
				}
			}
		},
		{
			appauth: 'Mrij(jnDkrjnKDrfijDejn',
			name: 'kovasali',
			domain: 'https://kovasali.fi',
			baseUrl: 'https://kovasali.fi',
			ajaxUrl: 'https://ajax.kovasali.fi',
			restUrl: 'https://api.kovasali.fi/api/1.0/',
			ecomUrl: 'https://kauppa.kovasali.fi',
			useRestLogin: false,
			useFitness: false,
			showWodConnect: false,
			showContractCancelButton: false,
			useTabDescriptions: true,
			useEventAddress: false,
			showNumberOfPeopleInside: false,
			useSecondaryShop: false,
			displayName: 'Kova Sali',
			displayChainName: 'Kova Sali',
			className: 'wisegym-kovasali',
			registerMailingLists: [1],
			customerTermsArticleId: 6,
			// Support form, these have to be updated!
			supportSurveyData: {
				custSupportSurvey: {
					surveyId: 7,
					textQuestionId: 2,
					contactQuestionId: 3
				}
			}
		},
	],
	isBranded: false,
	appId: "87257150",
	appVersion: `${ description } ${ version } - ${ versionDate }`, //This is just for error log. Keep the format of "version - date". Its important.
	version,
	bluetoothFallbackLocale: "fi-FI", // If some data not found in user choosed locale fallback to this locale. (Used door name, on door open)
	defaultClassName: 'wisegym',
	defaultScreenMode: 'light',

	// app features
	useGymFeatures: true,
	useGolfFeatures: false,
	useReservationWebsocket: false,
	
	// Register form
	usePersonDateOfBirth: true, // If true collects person birthday on register
	usePersonGuardian: true, // If true collects guardianName guardianBirthday on register (To use guradian settings usePersonDateOfBirth have to set true)
	usePersonGuardianContacts: true, // If true collects guardianPhone ja guardianEmail on register (To use guradian settings usePersonDateOfBirth have to set true)
	usePersonAdressInformation: true, // If true collects streetAddress, postalCode and city on register
	minAgeToRegister: 16, // User has to be at least years old to set own birthday on register form
	
	defaultPath: {
		path: '/',
		redirect: '/gym/welcome'
	},
	
	loginModalHostText: 'loginModal.gym',
	loginModalSelectText: 'loginModal.chooseGym',

	// PushNotifications
	hideNotificationSettings: false,
	// topics can be overwritten by getmobileappsettings endpoint
	// generate topics by host

	get topics() {
		const topics = {
			'wisegym-general-fi': {
				label: 'WiseGym uutiset'
			},
			'wisegym-general-en': {
				label: 'WiseGym news'
			}
		}

		for (let host of this.hosts) {
			// Finnish
			const newsKey = `${ host.name }-news-fi`
			const newsLabel = `${ host.displayName } uutiset`
			const offersKey = `${ host.name }-offers-fi`
			const offersLabel = `${host.displayName} tarjoukset`
			
			//English
			const newsKeyEn = `${ host.name }-news-en`
			const newsLabelEn = `${ host.displayName } news`
			const offersKeyEn = `${ host.name }-offers-en`
			const offersLabelEn = `${host.displayName} offers`

			//Swedish
			const newsKeySv = `${ host.name }-news-sv`
			const newsLabelSv = `${ host.displayName } nyheter`
			const offersKeySv = `${ host.name }-offers-sv`
			const offersLabelSv = `${host.displayName} erbjudande`

			//German
			const newsKeyDe = `${ host.name }-news-de`
			const newsLabelDe = `${ host.displayName } Neuigkeiten`
			const offersKeyDe = `${ host.name }-offers-de`
			const offersLabelDe = `${host.displayName} Angebote`
			
			topics[newsKey] = { label: newsLabel };
			topics[offersKey] = { label: offersLabel };
			topics[newsKeyEn] = { label: newsLabelEn };
			topics[offersKeyEn] = { label: offersLabelEn };
			topics[newsKeySv] = { label: newsLabelSv };
			topics[offersKeySv] = { label: offersLabelSv };
			topics[newsKeyDe] = { label: newsLabelDe };
			topics[offersKeyDe] = { label: offersLabelDe };
		}

		return topics;
	},

	get topicDefaults() {
		const topics = {
			'wisegym-news-fi': false,
			'wisegym-news-en': false,
			'wisegym-news-sv': false,
			'wisegym-news-de': false
		}

		for(let host of this.hosts) {
			const newsKey = `${ host.name }-news-fi`
			const offersKey = `${host.name}-offers-fi`
			const newsKeyEn = `${ host.name }-news-en`
			const offersKeyEn = `${ host.name }-offers-en`
			const newsKeySv = `${ host.name }-news-sv`
			const offersKeySv = `${ host.name }-offers-sv`
			const newsKeyDe = `${ host.name }-news-de`
			const offersKeyDe = `${ host.name }-offers-de`
			
			topics[newsKey] = false;
			topics[offersKey] = false;
			topics[newsKeyEn] = false;
			topics[offersKeyEn] = false;
			topics[newsKeySv] = false;
			topics[offersKeySv] = false;
			topics[newsKeyDe] = false;
			topics[offersKeyDe] = false;
		}

		return topics;
	},
	notificationRedirects: {
		news: 'today/article/',
		text: 'account/notifications/oldnotifications'
	},

	refreshEventDataMinutes: 3,
  // Validity information
	validityInformation: {
		showRoleValidity: false
	},
	// Check-In
	onCheckInValidateLocation: true, // If true user location will be validated on check-in as normally on door open (GPS/BEACON)
	// Door open
	locationSearchTimeout: 10000,
	reuseLocationConfirmationLastMinutes: 5, // If succesful door open, how long user can re-use same validation, without needed to do confirm location
	validateLocationInsideDevLocation: true, // If true location for door open can validate from devLocation coordinates and from locationId coordinates / gym event confirm inside dec location
	// Debug
	debug: false, // Show debug information (for example door open)
	vuexLogger: false, // Vuex logger logs actions, mutations in console. (Helps debug code), (Vue-devtools chrome extension at the moment still beta for Vue 3) https://github.com/vuejs/devtools/releases
	devLocation: [
		{ lat: 61.494537003032484, lng: 21.797595883526874 },
		{ lat: 61.49195628649641, lng: 21.7971345436054 }, 
		{ lat: 61.492673173669864, lng: 21.79146971852312 }, 
		{ lat: 61.49473669241433, lng: 21.791759397078465 }  
	]
};